import { render } from "./PhoneFormat.vue?vue&type=template&id=cd76588e"
import script from "./PhoneFormat.vue?vue&type=script&lang=js"
export * from "./PhoneFormat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__